import { SET_PROFILE, SET_USER_ROUTE } from "./actionTypes";

export const setUserInfo = info => ({
  type: SET_PROFILE,
  payload: info,
});

export const setUserRoute = route => ({
  type: SET_USER_ROUTE,
  payload: route,
});
